import { IFeatureGroupBase } from '../../models/features';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListFeatureGroupsProps {
  search?: string;
  limit?: number;
  page?: number;
}

export interface IFeatureGroupListItem extends IFeatureGroupBase {
  featuresCount: number;
  usersCount: number;
}

export type IFeatureGroupList = IListResponse<IFeatureGroupListItem>;

export const listFeatureGroupsService = async (
  filters: IListFeatureGroupsProps,
): Promise<IFeatureGroupList> => {
  const params =
    filters && Object.keys(filters).length !== 0
      ? {
          search: filters.search || undefined,
          limit: filters.limit,
          page: filters.page,
        }
      : undefined;

  const { data } = await jhsfBookingsApi.get<IFeatureGroupList>(
    '/feature-groups',
    {
      params,
    },
  );

  return data;
};
